import * as React from 'react';

const DoubleLandscape = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={18} viewBox="0 0 22 18" {...props}>
        <g
            fill="none"
            fillRule="nonzero"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            transform="translate(1 .667)"
        >
            <path d="M15.625 2.708v-.815A1.676 1.676 0 0 0 13.958.208H2.292A1.676 1.676 0 0 0 .625 1.893v7.88a1.676 1.676 0 0 0 1.667 1.685M9.45 16.458l3.698-5.255a1.25 1.25 0 0 1 1.965-.107l4.115 4.702M9.063 8.958a.313.313 0 1 1 0 .625.313.313 0 0 1 0-.625" />
            <rect width={14.375} height={11.25} x={5} y={5.208} rx={1.029} />
        </g>
    </svg>
);
export default DoubleLandscape;
